module.exports = __webpack_public_path__ + "img/icon-facebook.e7678b88.png";